    <header class="page-head">
      <div>
        <h1 class="page-title">Other Services</h1>
        <p class="page-subtitle">Explore additional services and products available through Central Profile.</p>
      </div>
    </header>

    <section class="catalog-grid">
      <article class="catalog-card span-4" *ngFor="let service of services">
        <span class="tag">{{ service.tag }}</span>
        <h2 class="section-title">{{ service.name }}</h2>
        <p class="label">{{ service.description }}</p>
        <div class="btn-row btn-row-spaced-top">
          <a class="btn btn-primary" routerLink="/orders">Order</a>
          <a class="btn btn-secondary" routerLink="/checkout">Checkout</a>
        </div>
      </article>
    </section>
